import { ProductDto } from '@app/types/product.type';

/**
 * Вычислить дату следующего платежа на основе product.duration
 */
export function calculateNextPaymentDate(product: ProductDto): string {
  const now = new Date();
  const nextDate = new Date(now);

  if (product.duration.years === 1) {
    nextDate.setFullYear(now.getFullYear() + 1);
  } else if (product.duration.months === 1) {
    nextDate.setMonth(now.getMonth() + 1);
  } else if (product.duration.days) {
    nextDate.setDate(now.getDate() + product.duration.days);
  } else {
    // По умолчанию через месяц
    nextDate.setMonth(now.getMonth() + 1);
  }

  return nextDate.toISOString();
}

/**
 * Вычислить billingPeriod на основе product.duration
 */
export function getBillingPeriod(product: ProductDto): 'monthly' | 'yearly' {
  if (product.duration.years === 1) {
    return 'yearly';
  }
  return 'monthly';
}
